import patterns from '@/shared/ui/styles/patterns.module.css';
import { SettingsFrame } from '@/modules/settings/components/SettingsFrame';
import { LocationCredentialsCard } from '@/modules/insurance/components/LocationCredentialsCard';
import { ProviderCredentialsTable } from '@/modules/insurance/components/ProviderCredentialsTable';
import { SetupReadinessBanner } from '@/modules/insurance/components/SetupReadinessBanner';
import { IvSubnav } from '../components/IvSubnav';

/**
 * Practice credentials inside the new Insurance Verification section. This is
 * the same experience as OLD Insurance Verification › Practice Credentials —
 * the same cards, hooks and backend records — so a value saved on either page
 * is immediately the value the other page shows and the value every
 * eligibility check sends (see backend provider.service.ts).
 */
export function CredentialsPage({
  embedded = false,
  level = 2,
}: { embedded?: boolean; level?: 2 | 3 } = {}) {
  return (
    <SettingsFrame
      embedded={embedded}
      level={level}
      id="settings-iv-credentials"
      pageClassName={patterns.page}
      title={embedded ? 'Practice Credentials' : 'Practice credentials'}
      subtitle="The legal name, tax ID and NPIs this location verifies insurance under. Electronic checks send the group NPI when set, otherwise the first provider's NPI. Shared with the older Insurance Verification pages."
    >
      {!embedded && <IvSubnav />}
      <SetupReadinessBanner />
      <LocationCredentialsCard />
      <ProviderCredentialsTable />
    </SettingsFrame>
  );
}
